var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Vilkår for "+_vm._s(_vm.vendor.name))]),_c('v-card',{staticClass:"mt-10"},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.organization.terms_rendered)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }